/** CoStar.Api.AptsNet.Aggregate.ViewModels.Messaging.CostMultiplierType */
export var CostMultiplierType;
(function (CostMultiplierType) {
    CostMultiplierType[CostMultiplierType["None"] = 0] = "None";
    CostMultiplierType[CostMultiplierType["Person"] = 1] = "Person";
    CostMultiplierType[CostMultiplierType["Vehicle"] = 2] = "Vehicle";
    CostMultiplierType[CostMultiplierType["Dog"] = 3] = "Dog";
    CostMultiplierType[CostMultiplierType["Cat"] = 4] = "Cat";
})(CostMultiplierType || (CostMultiplierType = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.Messaging.MoveInTimeframe */
export var MoveInTimeframe;
(function (MoveInTimeframe) {
    MoveInTimeframe[MoveInTimeframe["Unknown"] = 0] = "Unknown";
    MoveInTimeframe[MoveInTimeframe["Today"] = 1] = "Today";
    MoveInTimeframe[MoveInTimeframe["ThisMonth"] = 2] = "ThisMonth";
    MoveInTimeframe[MoveInTimeframe["NextMonth"] = 3] = "NextMonth";
    MoveInTimeframe[MoveInTimeframe["AfterNextMonth"] = 4] = "AfterNextMonth";
})(MoveInTimeframe || (MoveInTimeframe = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.Messaging.ContactOption */
export var ContactOption;
(function (ContactOption) {
    ContactOption[ContactOption["None"] = 0] = "None";
    ContactOption[ContactOption["Phone"] = 1] = "Phone";
    ContactOption[ContactOption["Email"] = 2] = "Email";
})(ContactOption || (ContactOption = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.Messaging.MoveReason */
export var MoveReason;
(function (MoveReason) {
    MoveReason[MoveReason["None"] = 0] = "None";
    MoveReason[MoveReason["MoreLessSpace"] = 1] = "MoreLessSpace";
    MoveReason[MoveReason["JobChange"] = 2] = "JobChange";
    MoveReason[MoveReason["FamilyEvent"] = 3] = "FamilyEvent";
    MoveReason[MoveReason["Relocation"] = 4] = "Relocation";
    MoveReason[MoveReason["Other"] = 5] = "Other";
})(MoveReason || (MoveReason = {}));
